import { useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'
import styled from 'styled-components'

import { reatomFollowersFilter } from '@root/features/user/user-connections'
import { capitalize } from '@root/shared/core/StringUtil'
import { useTranslation } from '@root/shared/localization'
import { Dialog, Input, SearchIcon } from '@root/shared/ui-kit'

import { userConnectionsFollowersModal } from '../../atoms/user-connections-followers-modal'

import { UserConnectionsFollowersListModal } from './user-connections-followers-list-modal'

import type { DelugeId } from '@root/entities/user-short'

export const UserConnectionsFollowersModal = () => {
  const { t } = useTranslation()
  const [modal, setModal] = useAtom(userConnectionsFollowersModal)

  const title = capitalize(
    modal
      ? [t('common.follower_other'), `(${modal.followers})`].join(' ')
      : t('common.follower_other'),
  )

  return (
    <Dialog
      describedBy={title}
      open={!!modal}
      onOpenChange={() => setModal(undefined)}
    >
      <Dialog.Header title={title} />

      {modal ? (
        <UserConnectionsFollowersFilter
          onNavigateToProfile={() => setModal(undefined)}
          delugeId={modal.delugeId}
        />
      ) : undefined}
    </Dialog>
  )
}

type UserConnectionsFollowersFilterProps = {
  delugeId: DelugeId
  onNavigateToProfile: () => void
}

export const UserConnectionsFollowersFilter = ({
  delugeId,
  onNavigateToProfile,
}: UserConnectionsFollowersFilterProps) => {
  const { t } = useTranslation()

  const followersFilter = useMemo(
    // eslint-disable-next-line @reatom/unit-naming-rule
    () => reatomFollowersFilter(delugeId),
    [delugeId],
  )

  const [searchQuery, setSearchQuery] = useAtom(followersFilter.searchQueryAtom)

  return (
    <Root>
      <Head>
        <Input
          size="m"
          startContent={<Icon size={16} />}
          value={searchQuery}
          onChange={(s) => setSearchQuery(s.target.value)}
          placeholder={t('common.username')}
        />
      </Head>
      <UserConnectionsFollowersListModal
        onNavigateToProfile={onNavigateToProfile}
        followersFilter={followersFilter}
      />
    </Root>
  )
}

const Icon = styled(SearchIcon)`
  color: var(--text-9);
`

const Root = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  padding: 0 16px 12px;
  overflow: auto;
  width: 440px;
  min-height: 460px;
`

const Head = styled.div`
  z-index: 1;
  position: sticky;
  top: 0;
  padding: 12px 0;
`
